(function (angular, app) {
   "use strict";

    angular.module(app.modules.common.name)
        .constant(app.modules.common.constants.equipmentlist,
        
         [
            {
               id: 1
               , name : "Driver"
               , friendly : "Driver"
               , code : "DR"
            }
            ,{
               id : 2
               , name: "Wood2"
               , friendly : "2 Wood"
               , code : "2W"
            }
            ,{
               id : 3
               , name: "Wood3"
               , friendly: "3 Wood"
               , code : "3W"
            }
            ,{
               id : 4
               , name: "Wood4"
               , friendly: "4 Wood"
               , code : "4W"
            }
            ,{
               id : 5
               , name: "Wood5"
               , friendly: "5 Wood"
               , code : "5W"
            }
            ,{
               id : 6
               , name: "Wood6"
               , friendly: "6 Wood"
               , code : "6W"
            }
            ,{
               id : 7
               , name: "Wood7"
               , friendly: "7 Wood"
               , code : "7W"
            }
            ,{
               id : 8
               , name: "Wood8"
               , friendly: "8 Wood"
               , code : "8W"
            }
            ,{
               id : 9
               , name: "Wood9"
               , friendly: "9 Wood"
               , code : "9W"
            }
            ,{
               id : 10
               , name: "Hybrid1"
               , friendly: "1 Hybrid"
               , code : "1H"
            }
            ,{
               id : 11
               , name: "Hybrid2"
               , friendly: "2 Hybrid"
               , code : "2H"
            }
            ,{
               id : 12
               , name: "Hybrid3"
               , friendly: "3 Hybrid"
               , code : "3H"
            }
            ,{
               id : 13
               , name: "Hybrid4"
               , friendly: "4 Hybrid"
               , code : "4H"
            }
            ,{
               id : 14
               , name: "Hybrid5"
               , friendly: "5 Hybrid"
               , code : "5H"
            }
            ,{
               id : 15
               , name: "Hybrid6"
               , friendly: "6 Hybrid"
               , code : "6H"
            }
            ,{
               id : 16
               , name: "Hybrid7"
               , friendly: "7 Hybrid"
               , code : "7H"
            }
            ,{
               id : 17
               , name: "Hybrid8"
               , friendly: "8 Hybrid"
               , code : "8H"
            }
            ,{
               id : 18
               , name: "Hybrid9"
               , friendly: "9 Hybrid"
               , code : "9H"
            }
            ,{
               id : 19
               , name: "Iron1"
               , friendly: "1 Iron"
               , code : "1I"
            }
            ,{
               id : 20
               , name: "Iron2"
               , friendly: "2 Iron"
               , code : "2I"
            }
            ,{
               id : 21
               , name: "Iron3"
               , friendly: "3 Iron"
               , code : "3I"
            }
            ,{
               id : 22
               , name: "Iron4"
               , friendly: "4 Iron"
               , code : "4I"
            },
            {
               id : 23
               , name: "Iron5"
               , friendly: "5 Iron"
               , code : "5I"
            }
            ,{
               id : 24
               , name: "Iron6"
               , friendly: "6 Iron"
               , code : "6I"
            }
            ,{
               id : 25
               , name: "Iron7"
               , friendly: "7 Iron"
               , code : "7I"
            }
            ,{
               id : 26
               , name: "Iron8"
               , friendly: "8 Iron"
               , code : "8I"
            }
            ,{
               id : 27
               , name: "Iron9"
               , friendly: "9 Iron"
               , code : "9I"
            }
            ,{
               id : 28
               , name: "PitchingWedge"
               , friendly: "Pitching Wedge"
               , code : "PW"
            }
            ,{
               id : 29
               , name: "GapWedge"
               , friendly: "Gap Wedge"
               , code : "GW"
            }
            ,{
               id : 30
               , name: "SandWedge"
               , friendly: "Sand Wedge"
               , code : "SW"
            }
            , {
               id: 31
               , name: "LobWedge"
               , friendly: "Lob Wedge"
               , code: "LW"
            }
            , {
               id: 32
               , name: "Putter"
               , friendly: "Putter"
               , code: "PT"
            }
            , {
               id: 33
               , name: "Wood"
               , friendly: "Wood"
               , code: "WD"
            }
            , {
               id: 34
               , name: "Hybrid"
               , friendly: "Hybrid"
               , code: "HY"
            }
            , {
               id: 35
               , name: "Iron"
               , friendly: "Iron"
               , code: "IR"
            }
            , {
               id: 36
               , name: "Wedge"
               , friendly: "Wedge"
               , code: "WG"
            }
            
            
            
         ]      
        );
}(angular, app));
